import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.pad-start.js";

/**
 * 将字符串版本号转换成数值版本号
 * @param version 字符串版本号
 *
 * @example `'7.1.7'` => `7010700`
 */
export function numberVersion(version) {
  return Number("".concat(version.split('.').map(function (x) {
    return x.padStart(2, '0');
  }).join(''), "00"));
}